import PropTypes from 'prop-types';
import React from 'react';

import EditWallet from './EditWallet';
import ViewWallet from './ViewWallet';

function Home({ isEditing, onEditToggle }) {
  return isEditing ? (
    <EditWallet onDone={onEditToggle} />
  ) : (
    <ViewWallet onEdit={onEditToggle} />
  );
}

Home.propTypes = {
  isEditing: PropTypes.bool.isRequired,
  onEditToggle: PropTypes.func.isRequired,
};

export default Home;
